import { Chip } from '@mui/material';

export const stageStyles = {
  Silver: { bg: 'linear-gradient(135deg, #9aa4b2, #cfd6de)', emoji: '🥈' },
  Gold: { bg: 'linear-gradient(135deg, #f4c430, #ffd95a)', emoji: '🥇' },
  Ruby: { bg: 'linear-gradient(135deg, #ff4d6d, #ff8fa3)', emoji: '💎' },
  Sapphire: { bg: 'linear-gradient(135deg, #3b82f6, #60a5fa)', emoji: '💠' },
  Platinum: { bg: 'linear-gradient(135deg, #3bf6f6, #8ef9f9)', emoji: '⭐' },
  Diamond: { bg: 'linear-gradient(135deg, #e25ae2, #f3a6f3)', emoji: '💎' },
  Bronze: { bg: 'linear-gradient(135deg, #e4c22c, #ecc238)', emoji: '🥉' },
};
// ✅ Stage Badge Component
const StageBadge = ({ stage }) => {
  const current = stageStyles[stage] || {};

  return (
    <Chip
      label={`${current.emoji || ''} ${stage}`}
      sx={{
        background: current.bg || '#ccc',
        color: '#000',
        fontWeight: 600,
        my: 0.7,
      }}
    />
  );
};
export default StageBadge;
